/**
 * Toast persistente de atualização PWA — título + botão «Atualizar»; sem reload automático.
 */
import { useToastStore } from '@/shared/ui/toast/toastStore'
import { applyPwaUpdate } from '@/shared/pwa/applyPwaUpdate'

export const PWA_UPDATE_TOAST_TITLE = 'Nova versão disponível'

/** Mensagem curta sob o título (pt-BR). */
export const PWA_UPDATE_TOAST_MESSAGE =
  'Atualize para continuar com a última versão. O app só recarrega quando você tocar em Atualizar.'

/** Mostra no máximo um toast de update ativo (dedupe por título). */
export function showPwaUpdateToast(): void {
  const alreadyVisible = useToastStore
    .getState()
    .toasts.some((toast) => toast.title === PWA_UPDATE_TOAST_TITLE)
  if (alreadyVisible) return

  useToastStore.getState().add(PWA_UPDATE_TOAST_MESSAGE, {
    title: PWA_UPDATE_TOAST_TITLE,
    variant: 'info',
    durationMs: 0,
    action: {
      label: 'Atualizar',
      style: 'primary',
      onClick: () => {
        void applyPwaUpdate()
      },
    },
  })
}
